import Modal from 'LuxKit/Modal/Modal'
import CruiseInclusionList from 'components/Cruises/CruiseInclusion/CruiseInclusionList'
import { useIntl } from 'react-intl'
import { useMemo } from 'react'
import { getCruisePortsByItinerary } from 'lib/cruises/cruiseUtils'

interface Props {
  offer: App.CruiseOffer
  evergreenInclusions: Array<App.PackageInclusion>
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
}

function CruiseOfferTileInclusionsModal({
  offer,
  evergreenInclusions,
  standardInclusions,
  luxPlusInclusions,
}: Props) {
  const intl = useIntl()
  const ports = useMemo(() => getCruisePortsByItinerary(offer.itinerary), [offer.itinerary])

  return <Modal
    title={intl.formatMessage({
      id: 'mtMEHLEIURxLOmMC7T6v',
      defaultMessage: 'What\u2019s included',
    })}
  >
    <CruiseInclusionList
      offer={offer}
      evergreenInclusions={evergreenInclusions}
      standardInclusions={standardInclusions}
      luxPlusInclusions={luxPlusInclusions}
      ports={ports}
      hideHeader
    />
  </Modal>
}

export default CruiseOfferTileInclusionsModal
